export default {
    SET_GRID: (state, payload) => {
        state.grid = payload;
    },

    SET_HOJAS: (state, payload) => {
        state.hojas = payload;
    },
}